import './styles/NavBar.scss';
import { AppContext, ExAppContext } from '../Context';
import { App_ViewModeMap, MemberUser_CommitteeTypeMap, System_DeviceOrientationMap } from '../assets/keyMap';
import { Fragment, useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';

//mui
import HomeIcon from '@mui/icons-material/Home';
// import QrCodeIcon from '@mui/icons-material/QrCode'; ---deprecated of unused
// import SearchIcon from '@mui/icons-material/Search'; ---deprecated of unused
import CelebrationIcon from '@mui/icons-material/Celebration';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import CellTowerIcon from '@mui/icons-material/CellTower';

// import AccountCircleIcon from '@mui/icons-material/AccountCircle'; ---deprecated of unused
import CollectionsIcon from '@mui/icons-material/Collections';
import ArticleIcon from '@mui/icons-material/Article';
import GroupsIcon from '@mui/icons-material/Groups';
import MmsIcon from '@mui/icons-material/Mms';
import PollIcon from '@mui/icons-material/Poll';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import AttachFileIcon from '@mui/icons-material/AttachFile';

//graphics
import SocialMediaIcon from '../assets/images/icons/socialMediaIcon.png';

//classes
import CommitteeType from '../exClasses/committeeType';
import Poll from '../exClasses/poll';
import MeetingInvitation from '../exClasses/meetingInvitation';

interface Props {
    viewMode: number
}

const NavBar: React.FC<Props> = ({ viewMode }) => {
    //context
    const appContext = useContext(AppContext);
    const exAppContext = useContext(ExAppContext);
    const [page, SetPage] = useState(0);
    //history
    const history = useHistory();

    //render functions
    const RenderMemberNavButtons = () => {
        return (
            <Fragment>
                <button className={'NavBar-nav-btn ' + (location.pathname.includes('/Home') ? 'selected' : '')} onClick={() => history.push('/Home')}>
                    <span className={'NavBar-nav-top-indicator ' + (location.pathname.includes('/Home') ? 'selected' : '')}></span>
                    <HomeIcon />
                    <span className='NavBar-nav-lbl'>Home</span>
                </button>
                <button className={'NavBar-nav-btn ' + ((location.pathname.includes('/Events') || location.pathname == '/MyEvents' || location.pathname == '/EventRegistrations') ? 'selected' : '')} onClick={() => history.push('/Events')}>
                    <span className={'NavBar-nav-top-indicator ' + ((location.pathname.includes('/Events') || location.pathname == '/MyEvents' || location.pathname == '/EventRegistrations') ? 'selected' : '')}></span>
                    <CelebrationIcon />
                    <span className='NavBar-nav-lbl'>Events</span>
                </button>
                <button className={'NavBar-nav-btn ' + (location.pathname.includes('/ViewEventGallery/Member') ? 'selected' : '')} onClick={() => history.push('/ViewEventGallery/Member')}>
                    <span className={'NavBar-nav-top-indicator ' + (location.pathname.includes('/ViewEventGallery/Member') ? 'selected' : '')}></span>
                    <CollectionsIcon />
                    <span className='NavBar-nav-lbl'>Photo Gallery</span>
                </button>
                <button className={'NavBar-nav-btn ' + (location.pathname.includes('/ViewDocuments') ? 'selected' : '')} onClick={() => history.push('/ViewDocuments/Member')}>
                    <span className={'NavBar-nav-top-indicator ' + (location.pathname.includes('/ViewDocuments') ? 'selected' : '')}></span>
                    <ArticleIcon />
                    <span className='NavBar-nav-lbl'>Resources</span>
                </button>
                <button className={'NavBar-nav-btn ' + (location.pathname.includes('/ViewDocuments') ? 'selected' : '')} onClick={() => history.push('/SocialMedia')}>
                    <span className={'NavBar-nav-top-indicator ' + (location.pathname.includes('/SocialMedia') ? 'selected' : '')}></span>
                    <img src={SocialMediaIcon}/>
                    <span className='NavBar-nav-lbl'>Social Media</span>
                </button>
            </Fragment>
        );
    }
    const RenderCommitteeNavButtons1 = () => {
        return (
            <Fragment>
                <button className='NavBar-nav-btn left' onClick={() => SetPage(page == 0 ? 1 : 0)}><ArrowLeftIcon /></button>
                <button className={'NavBar-nav-btn ' + (location.pathname.includes('/Home') ? 'selected' : '')} onClick={() => history.push('/Home')}>
                    <span className={'NavBar-nav-top-indicator ' + (location.pathname.includes('/Home') ? 'selected' : '')}></span>
                    <HomeIcon />
                    <span className='NavBar-nav-lbl'>Home</span>
                </button>
                <button className={'NavBar-nav-btn ' + (location.pathname.includes('/ViewMeetings') ? 'selected' : '')} onClick={() => history.push('/ViewMeetings')}>
                    <span className={'NavBar-nav-top-indicator ' + (location.pathname.includes('/ViewMeetings') ? 'selected' : '')}></span>
                    <GroupsIcon />
                    <span className='NavBar-nav-lbl'>Manage<br />Meetings</span>
                    {
                        CountPendingMeetingInvitations(exAppContext.meetingInvitations) > 0 ?
                            <span className='NavBar-notification-lbl'>{CountPendingMeetingInvitations(exAppContext.meetingInvitations)}</span>
                            :
                            null
                    }
                </button>
                <button className={'NavBar-nav-btn ' + (location.pathname.includes('/ViewEventGallery/Committee') ? 'selected' : '')} onClick={() => history.push('/ViewEventGallery/Committee')}>
                    <span className={'NavBar-nav-top-indicator ' + (location.pathname.includes('/ViewEventGallery/Committee') ? 'selected' : '')}></span>
                    <MmsIcon />
                    <span className='NavBar-nav-lbl'>Manage<br />Galleries</span>
                </button>
                <button className={'NavBar-nav-btn ' + (location.pathname.includes('/ViewPolls') ? 'selected' : '')} onClick={() => history.push('/ViewPolls')}>
                    <span className={'NavBar-nav-top-indicator ' + (location.pathname.includes('/ViewPolls') ? 'selected' : '')}></span>
                    <PollIcon />
                    <span className='NavBar-nav-lbl'>{IsSecretariat() ? 'Manage\nPolls' : 'View\nPolls'}</span>
                    {
                        GetUnvotedPollsCount(exAppContext.unvotedCurrentAndVotedPolls) > 0 ?
                            <span className='NavBar-notification-lbl'>{GetUnvotedPollsCount(exAppContext.unvotedCurrentAndVotedPolls)}</span>
                            :
                            null
                    }
                </button>
                <button className='NavBar-nav-btn right' onClick={() => SetPage(page == 0 ? 1 : 0)}><ArrowRightIcon /></button>
            </Fragment>
        );
    }
    const RenderCommitteeNavButtons2 = () => {
        return (
            <Fragment>
                <button className='NavBar-nav-btn left' onClick={() => SetPage(page == 0 ? 1 : 0)}><ArrowLeftIcon /></button>
                <button className={'NavBar-nav-btn ' + (location.pathname.includes('/ManageEventAttachments') ? 'selected' : '')} onClick={() => history.push('/ManageEventAttachments')}>
                    <span className={'NavBar-nav-top-indicator ' + (location.pathname.includes('/ManageEventAttachments') ? 'selected' : '')}></span>
                    <AttachFileIcon />
                    <span className='NavBar-nav-lbl'>Manage<br />Attachments</span>
                </button>
                <button className={'NavBar-nav-btn ' + (location.pathname.includes('/ViewDocuments') ? 'selected' : '')} onClick={() => history.push('/ViewDocuments/Committee')}>
                    <span className={'NavBar-nav-top-indicator ' + (location.pathname.includes('/ViewDocuments') ? 'selected' : '')}></span>
                    <FileCopyIcon />
                    {
                        IsSecretariat() ?
                            <span className='NavBar-nav-lbl'>Manage<br />Resources</span>
                            :
                            <span className='NavBar-nav-lbl'>View<br />Resources</span>
                    }
                </button>
                {
                    IsSecretariat() ?
                        <button className={'NavBar-nav-btn ' + (location.pathname.includes('/ManageNotifications') ? 'selected' : '')} onClick={() => history.push('/ManageNotifications')}>
                            <span className={'NavBar-nav-top-indicator ' + (location.pathname.includes('/ManageNotifications') ? 'selected' : '')}></span>
                            <CellTowerIcon />
                            <span className='NavBar-nav-lbl'>Manage<br />Notifications</span>
                        </button>
                        :
                        null
                }
                <div className='NavBar-nav-btn' />
                <button className='NavBar-nav-btn right' onClick={() => SetPage(page == 0 ? 1 : 0)}><ArrowRightIcon /></button>
            </Fragment>
        );
    }

    //exe functions
    const GetUnvotedPollsCount = (polls: Poll[]) => {
        let res = 0;
        polls.map((_poll: Poll) => {
            if (!_poll.voterIDs.join(',').includes(appContext.user.userID)) {
                res += 1;
            }
        });
        return res;
    }
    const CountPendingMeetingInvitations = (meetingInvitations: MeetingInvitation[]) => {
        let res = 0;
        meetingInvitations.map((invitation: MeetingInvitation) => {
            if(invitation.invitation_status == 0)
                res += 1;
        });

        return res;
    }

    //check functions
    const IsSecretariat = () => {
        let res = false;
        exAppContext.committeeTypes.map((committeeType: CommitteeType) => {
            if (committeeType.label.toLowerCase() == 'secretariat' && committeeType.committee_typeID == appContext.user.committee_typeID)
                res = true;
        });

        return res;
    }

    return (
        <div className={'NavBar ' + (appContext.deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ? 'landscape' : 'portrait')}>
            {
                viewMode == App_ViewModeMap.MEMBER ?
                    (
                        RenderMemberNavButtons()
                    )
                    :
                    (
                        page == 0 ?
                            RenderCommitteeNavButtons1()
                            :
                            RenderCommitteeNavButtons2()
                    )
            }
        </div>
    );
};
export default NavBar;